import Vue from 'vue'
import Router from 'vue-router'
import Inicio from '../views/Inicio.vue'
import Bases from '../views/bases/Bases.vue'
import Base from '../views/bases/Base.vue'
import Iniciada from '../views/auth/Iniciada.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '/inicio', name: 'inicio', component: Inicio },
    { path: '/iniciada', name: 'iniciada', component: Iniciada },
    { path: '/bases/inicio', name: 'bases', component: Bases },
    { path: '/base/:idBase', name: 'base_detalle', component: Base },
    { path: '*', redirect: '/inicio' }
  ]
})
